import React, { Component } from "react";
import "./premium.css";
import editor from "./editor.jpg";
import academ from "./academ.jpg";
import bio from "./bio.jpg";
import chil from "./chil.jpg";
import fic from "./fic.jpg";
import life from "./layf.jpg";
import polit from "./polit.jpg";
import fan from "./fan.jpg";
import most from "./popula.jpg";
import art from "./art.jpg";
import bus from "./busines.jpg";
import envi from "./envi.jpg";
import heal from "./heal.jpg";
import grow from "./grow.jpg";
import reli from "./reli.jpg";
import tec from "./tec.jpg";
import market from "./pm.png";
import mac from "./mac.jpg";
import not from "./not.jpg";
import pdflogo from "./pdflog.png";

class Premium extends Component {
  state = {};

  render() {
    return (
      <React.Fragment>
        <div className="bek">
          <div className="mainpart container">
            <div className="leftprem container">
              <p className="gopr">Go premium. Be happy</p> <br />
              <div className="kvadrat container">
                <div className="insidee">
                  <div className="leftkvad container">
                    <i className="fa fa-bolt "></i> <br />
                    <p className="wait">Do'nt like waiting?</p>
                    <p className="premmatn">
                      Just search for the book you love and hit{" "}
                      <span className="qui">
                        Quick <br />
                        preview
                      </span>{" "}
                      or <span className="qui">Quick download</span>.
                    </p>
                  </div>
                  <div className="rightkvad container">
                    <i className="fas fa-sync "></i> <br />
                    <p className="neve">Never lose a file again</p>
                    <p className="premmatn">
                      Let your phone on the train? Your files are safe. <br />
                      Just sign in to PDF Drive from{" "}
                      <span className="qui">any device</span>, and <br />
                      your files will be there waiting for you.
                    </p>
                  </div>
                </div>
                <div className="insideee">
                  <div className="leftkvad container">
                    <i className="fa fa-space-shuttle "></i> <br />
                    <p className="wait3">Prime Reading</p>
                    <p className="premmatn">
                      Enjoy unlimited reading on any device, with over <br />
                      <span className="qui">million books</span>
                      ,magazines,comics,articles and <br />
                      more
                    </p>
                  </div>
                  <div className="rightkvad container">
                    <i className="fas fa-cloud "></i> <br />
                    <p className="wait4">No more broken links</p>
                    <p className="premmatn">
                      Remote file not available? Get your{" "}
                      <span className="qui">
                        unlimited <br />
                        cloud storage
                      </span>{" "}
                      for your favourite online content <br />
                      to access it leter at anytime
                    </p>
                  </div>
                </div>
                <div className="knppar">
                  <button className="freebtn">
                    Start your 7-day free trial
                  </button>
                </div>
                <p className="after">
                  After your free trial, PDF Drive Premium is just $29.99/year.
                  Cancel anytime.
                </p>
                <div className="pdfmonth">
                  <div className="leftmonth">
                    <div className="en">
                      <p className="uu">PDF Drive Premium</p>
                      <p className="narx">
                        $3.99 / month <br />
                        $29.99 / year
                      </p>
                      <p className="zz">Start your 7-day free trial</p> <br />
                      <div className="das">
                        <span className="checkspan">
                          <i className="fas fa-check"></i>
                          <p>Unlimited cloud storage</p>
                        </span>
                        <span className="checkspan">
                          <i className="fas fa-check"></i>
                          <p>Exclusive experiences</p>
                        </span>
                        <span className="checkspan">
                          <i className="fas fa-check"></i>
                          <p>Ad free</p>
                        </span>
                      </div>
                      <button className="getpremm">Get Premium</button>
                    </div>
                  </div>
                  <div className="leftmonth">
                    <div className="en">
                      <p className="uuu">PDF Drive Free </p>
                      <p className="narxx">$0.00 / month </p>

                      <div className="dass">
                        <span className="checkspan">
                          <i className="fas fa-check"></i>
                          <p>100 MB cloud storage</p>
                        </span>
                        <span className="checkspan">
                          <i className="fas fa-check"></i>
                          <p>Exclusive experiences</p>
                        </span>
                        <span className="checkspan">
                          <i className="fas fa-check"></i>
                          <p>Ad free</p>
                        </span>
                      </div>
                      <button className="getpremm">Get Premium</button>
                    </div>
                  </div>
                </div>
                <div className="pass">
                  <p className="frequ">Frequently Asked Questions</p>
                  <p className="neeed">
                    Why do you need my payment details? <br />{" "}
                  </p>
                  <p className="ned2">
                    What does the unlimited cloud space for? <br />
                  </p>
                  <p className="ned3">Is my cretid card information safe? </p>
                </div>
              </div>
            </div>
            <div className="rightprem">
              <div className="klarall">
                <p>
                  <span>Pdfdrive:hope</span> Give books away. Get books you
                  wont.
                </p>
                <div className="hamakitob">
                  <div>
                    <a href="https://www.pdfdrive.com/category/113">
                      <span className="poo">
                        <img src={editor} alt="" /> <p>Editor's Picks</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/6">
                      <span className="poo">
                        <img src={academ} alt="" /> <p>Academic & Education</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/16">
                      <span className="poo">
                        <img src={bio} alt="" /> <p>Biograhpy</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/17">
                      <span className="poo">
                        <img src={chil} alt="" /> <p>Children & Youth</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/11">
                      <span className="poo">
                        <img src={fic} alt="" /> <p>Fiction & Literature</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/19">
                      <span className="poo">
                        <img src={life} alt="" /> <p>Lifestyle</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/15">
                      <span className="poo">
                        <img src={polit} alt="" /> <p>Politics & Laws</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/15">
                      <span className="poo">
                        <img src={fan} alt="" /> <p>Science & Research</p>
                      </span>
                    </a>
                  </div>
                  <div>
                    <a href="https://www.pdfdrive.com/category/112">
                      <span className="pooo">
                        <img src={most} alt="" /> <p>Most Popular</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/1">
                      <span className="pooo">
                        <img src={art} alt="" /> <p>Art</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/3">
                      <span className="pooo">
                        <img src={bus} alt="" /> <p>Business & Career</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/18">
                      <span className="pooo">
                        <img src={envi} alt="" /> <p>Environment</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/8">
                      <span className="pooo">
                        <img src={heal} alt="" /> <p>Health & Fitness</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/4">
                      <span className="pooo">
                        <img src={grow} alt="" /> <p>Personal Growth</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/10">
                      <span className="pooo">
                        <img src={reli} alt="" /> <p>Religion</p>
                      </span>
                    </a>
                    <a href="https://www.pdfdrive.com/category/5">
                      <span className="pooo">
                        <img src={tec} alt="" /> <p>Technology</p>
                      </span>
                    </a>
                  </div>
                </div>
                <p className="inbo">
                  Get Top Trending Free Books in Your Inbox
                </p>
                <span className="emalga">
                  <input type="text" placeholder="Enter you email" />
                  <button>Subscribe</button>
                </span>
                <a href="https://www.pdfdrive.com/app">
                  <img className="mar" src={market} alt="" />
                </a>
                <p className="trendingtoday">Trending Today</p>
                <span className="macb">
                  <img src={mac} alt="" />
                  <p className="perfor">
                    Performance is King: Join The World's Leading <br />
                    Native Ad Network-Revcontent
                  </p>
                  <p className="rev">Revcontent</p>
                </span>
                <span className="macb">
                  <img src={not} alt="" />
                  <p className="perfor">
                    Join Revcontent: Join The World's Fastest <br /> Growing
                    Native Ad Network-Revcontent
                  </p>
                  <p className="rev">Revcontent</p>
                </span>
              </div>
            </div>
          </div>
          <div className="premfooter container">
            <div className="premin container">
              <img className="pdflooo" src={pdflogo} alt="" />

              <div>
                <p>Company</p>
                <a href="https://www.pdfdrive.com/home/about">About</a>
                <br />
                <a href="https://www.pdfdrive.com/app">Mobile App</a> <br />
                <a href="https://www.pdfdrive.com/home/terms">
                  Terms & Privacy
                </a>
              </div>
              <div>
                <p>Social</p>
                <a href="https://twitter.com/pdfdrive">Twitter</a>
                <br />
                <a href="https://www.facebook.com/pdfdrive">Facebook</a> <br />
                <span className="donher">
                  <a href="https://www.pdfdrive.com/donate">Donate</a>
                  <i className="fa fa-heart"></i>
                </span>
              </div>
              <div>
                <p>Help</p>
                <a href="https://www.pdfdrive.com/home/contact">Contact Us</a>
                <br />
                <a href="https://www.pdfdrive.com/home/contact">
                  Feedback
                </a>{" "}
                <br />
                <a href="https://www.pdfdrive.com/home/dmca">
                  DMCA & Copyright
                </a>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default Premium;
